import React from "react";

export default function OfficeIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="currentColor"
        d="M16.415 9.082h-8.83l-.085 3h.75c.27-1.643.534-1.788 2.54-1.853l.44-.015v7.636c0 .706-.148.873-1.347.982v.75h4.234v-.75c-1.206-.109-1.355-.276-1.355-.982v-7.636l.447.015c2.007.065 2.271.21 2.541 1.853h.75l-.085-3Z"
      />
      <path
        fill="currentColor"
        d="M21 6.832v14.25a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-18a3 3 0 0 1 3-3h8.25L21 6.832Zm-4.5 0a2.25 2.25 0 0 1-2.25-2.25v-3H6a1.5 1.5 0 0 0-1.5 1.5v18a1.5 1.5 0 0 0 1.5 1.5h12a1.5 1.5 0 0 0 1.5-1.5V6.832h-3Z"
      />
    </svg>
  );
}
